import { Box } from '@mui/material';
import { forwardRef, HTMLAttributes } from 'react';
import { getIconSvgPath } from 'src/utils/image';
import { adminTokens } from './adminTokens';

type PhosphorWeight = 'regular' | 'bold' | 'fill' | 'duotone' | 'light' | 'thin';

export type PhosphorIconProps = {
    name: string;
    weight?: PhosphorWeight;
    size?: number;
    color?: string;
};

export default function PhosphorIcon({
    name,
    weight = 'regular',
    size = 16,
    color,
}: PhosphorIconProps) {
    const src = getIconSvgPath(name, weight);
    if (!src) return null;

    if (!color) {
        return (
            <Box
                component="img"
                src={src}
                alt=""
                sx={{ width: size, height: size, flexShrink: 0, display: 'block' }}
            />
        );
    }

    return (
        <Box
            aria-hidden
            sx={{
                width: size,
                height: size,
                flexShrink: 0,
                bgcolor: color,
                mask: `url(${src}) no-repeat center / contain`,
                WebkitMask: `url(${src}) no-repeat center / contain`,
            }}
        />
    );
}

/** MUI Select `IconComponent` — Phosphor caret-down */
export const PhosphorSelectIcon = forwardRef<HTMLSpanElement, HTMLAttributes<HTMLSpanElement>>(
    function PhosphorSelectIcon(props, ref) {
        const { className, style, ...rest } = props;
        return (
            <Box
                ref={ref}
                component="span"
                className={className}
                style={style}
                {...rest}
                sx={{ display: 'inline-flex', alignItems: 'center', mr: 0.5, pointerEvents: 'none' }}
            >
                <PhosphorIcon name="caret-down" size={12} color={adminTokens.gray500} />
            </Box>
        );
    },
);
